const siteInfo = {
  fib: {
    title: '昆仑数据信息平台',
    logo: 'kunlun.png',
  },
  training: {
    title: '星图考培信息系统',
    logo: 'starmap.png',
  },
  interview: {
    title: '面试系统',
    logo: 'interview.png',
  },
  job: {
    title: '求职系统',
    logo: 'job.png',
  },
  teaching: {
    title: '芥末学院教务系统',
    logo: 'teaching.png',
  },
};

export default siteInfo;
